/* eslint no-bitwise: "off", no-param-reassign: "off" */

import * as b64toBlob from "b64-to-blob";
import { savebase64AsPDF, savebase64AsType } from "util/downloadMobile";
import * as XLSX from "xlsx";

const fakeClick = (element) => {
    const event = document.createEvent("MouseEvents");

    event.initMouseEvent("click", true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    element.dispatchEvent(event);
};

export const downloadPdf = (name, data) => {
    const urlObject = window.URL || window.webkitURL || window;
    const exportBlob = b64toBlob(data, "application/pdf");
    if (!window.cordova) {
        if ("msSaveBlob" in navigator) {
            /**
             * Prefer msSaveBlob if available - Edge supports a[download] but ignores the filename provided,
             * using the blob UUID instead
             * msSaveBlob will respect the provided filename
             */
            navigator.msSaveBlob(exportBlob, name);
        } else if ("download" in HTMLAnchorElement.prototype) {
            const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");

            saveLink.href = urlObject.createObjectURL(exportBlob);
            saveLink.download = name;
            fakeClick(saveLink);
        } else {
            throw new Error("Neither a[download] nor msSaveBlob is available");
        }
    }
    if (window.cordova) {
        let folderpath;
        const contentType = "application/pdf";
        if (window.cordova.platformId === "android") {
            const path = window.cordova.file.externalRootDirectory;
            folderpath = `${path}download/`;
        }
        if (window.cordova.platformId === "ios") {
            folderpath = window.cordova.file.documentsDirectory;
        }
        savebase64AsPDF(folderpath, name, data, contentType);
    }
};

export const downloadXls = (name, data) => {
    if (!window.cordova) {
        const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
        saveLink.href = `data:application/vnd.ms-excel;base64,${window.atob(data)}`;
        saveLink.download = name;
        fakeClick(saveLink);
    }
    if (window.cordova) {
        const contentType = "application/vnd.ms-excel";
        let folderpath;
        if (window.cordova.platformId === "android") {
            const path = window.cordova.file.externalRootDirectory;
            folderpath = `${path}download/`;
        }
        if (window.cordova.platformId === "ios") {
            folderpath = window.cordova.file.documentsDirectory;
        }
        savebase64AsType(folderpath, name, window.atob(data), contentType);
    }
};

export const downloadTxt = (name, data) => {
    if (!window.cordova) {
        const urlObject = window.URL || window.webkitURL || window;
        const exportBlob = b64toBlob(data, "text/plain");
        const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");

        saveLink.href = urlObject.createObjectURL(exportBlob);
        saveLink.download = name;
        fakeClick(saveLink);
    }
    if (window.cordova) {
        let folderpath;
        const contentType = "text/plain";
        if (window.cordova.platformId === "android") {
            const path = window.cordova.file.externalRootDirectory;
            folderpath = `${path}download/`;
        }
        if (window.cordova.platformId === "ios") {
            folderpath = window.cordova.file.documentsDirectory;
        }
        savebase64AsType(folderpath, name, data, contentType);
    }
};

export const download = (name, data) => {
    const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
    const mediaType = "application/octet-stream";
    saveLink.href = `data:${mediaType};base64,${data}`;
    saveLink.download = name;
    fakeClick(saveLink);
};

export const downloadLink = (name, path) => {
    const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
    saveLink.href = path;
    saveLink.target = "_blank";
    saveLink.download = name;
    fakeClick(saveLink);
};

export const downloadCSVFile = (name, data) => {
    if (!window.cordova) {
        const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
        saveLink.href = `data:text/plain;charset=ISO-8859-1,${window.atob(data)}`;
        saveLink.download = name;
        fakeClick(saveLink);
    }
    if (window.cordova) {
        const contentType = "text/csv";
        let folderpath;
        if (window.cordova.platformId === "android") {
            const path = window.cordova.file.externalRootDirectory;
            folderpath = `${path}download/`;
        }
        if (window.cordova.platformId === "ios") {
            folderpath = window.cordova.file.documentsDirectory;
        }
        savebase64AsType(folderpath, name, window.atob(data), contentType);
    }
};

export async function getBlobContent(blob) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsText(blob);
    });
}

export const getHttpBlobContent = (blob) => {
    const url = URL.createObjectURL(blob);
    const request = new XMLHttpRequest();
    request.open("GET", url, false);
    request.send();
    URL.revokeObjectURL(url);
    return request.responseText;
};

export const downloadTxtTemplate = (name, data) => {
    if (!window.cordova) {
        const urlObject = window.URL || window.webkitURL || window;
        const exportBlob = b64toBlob(data, "text/plain");
        const saveLink = document.createElementNS("http://www.w3.org/1999/xhtml", "a");

        saveLink.href = urlObject.createObjectURL(exportBlob);
        saveLink.download = name;
        fakeClick(saveLink);
    }
    if (window.cordova) {
        let folderpath;
        const contentType = "text/plain";
        if (window.cordova.platformId === "android") {
            const path = window.cordova.file.externalRootDirectory;
            folderpath = `${path}download/`;
        }
        if (window.cordova.platformId === "ios") {
            folderpath = window.cordova.file.documentsDirectory;
        }
        savebase64AsType(folderpath, name, data, contentType);
    }
};

export const generateExcelBlobAndDownload = (newWorkbook, fileName, extension) => {
    let excelBlob;
    if (extension === "xlsx") {
        const binaryExcel = XLSX.write(newWorkbook, { bookType: "xlsx", type: "binary" });

        // Convert binary string to Blob
        const buffer = new ArrayBuffer(binaryExcel.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < binaryExcel.length; i++) {
            view[i] = binaryExcel.charCodeAt(i) & 0xff;
        }

        excelBlob = new Blob([buffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
    } else if (extension === "xls") {
        const binaryExcel = XLSX.write(newWorkbook, { bookType: "xls", type: "binary" });

        // Convert binary string to Blob
        const buffer = new ArrayBuffer(binaryExcel.length);
        const view = new Uint8Array(buffer);
        for (let i = 0; i < binaryExcel.length; i++) {
            view[i] = binaryExcel.charCodeAt(i) & 0xff;
        }

        excelBlob = new Blob([buffer], {
            type: "application/vnd.ms-excel",
        });
    }

    // Create a download link and trigger it
    const blobUrl = window.URL.createObjectURL(excelBlob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.setAttribute("download", fileName); // Set the file name and extension

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the URL object to free up memory
    window.URL.revokeObjectURL(blobUrl);
};

export const downloadTransferTemplateCsvAsExcel = (fileName, data) => {
    // descargo el blob en formato xls o xlsx
    const parts = fileName.split(".");
    const extension = parts.length > 1 ? parts[parts.length - 1] : null;

    // Parse CSV to worksheet
    const rows = data
        .trim()
        .split("\n")
        .map((row) => row.split(";"));

    // Columns to format as text to preserve leading zeros
    const columnsToFormat = [2, 3, 4, 5]; // `cbu`, `cuit`, `monto`, `voucher`

    rows.forEach((row, rowIndex) => {
        if (rowIndex > 0) {
            columnsToFormat.forEach((colIndex) => {
                if (colIndex === 0 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(22, "0"); // Ensure leading zeros remain
                }

                if (colIndex === 1 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(11, "0"); // Ensure leading zeros remain
                }

                if (colIndex === 2 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(13, "0"); // Ensure leading zeros remain
                }

                if (colIndex === 3 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(9, "0"); // Ensure leading zeros remain
                }
            });
        }
    });

    // Convert the rows array into a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    // Apply text format to specific cells to preserve leading zeros
    const columnsToFormatAsText = ["C", "D", "E", "F"]; // Example columns with leading zeros
    Object.keys(worksheet).forEach((cell) => {
        if (cell !== "!ref") {
            const column = cell.match(/[A-Z]+/)[0]; // Get column letter
            if (columnsToFormatAsText.includes(column) && cell !== `${column}1`) {
                worksheet[cell].z = "@"; // '@' sets the cell format to text
            }
        }
    });

    const newWorkbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(newWorkbook, worksheet, "Sheet1");

    generateExcelBlobAndDownload(newWorkbook, fileName, extension);
};

export const downloadEcheqTemplateCsvAsExcel = (fileName, data) => {
    // descargo el blob en formato xls o xlsx
    const parts = fileName.split(".");
    const extension = parts.length > 1 ? parts[parts.length - 1] : null;

    // Parse CSV to worksheet
    const rows = data
        .trim()
        .split("\n")
        .map((row) => row.split(";"));

    // Columns to format as text to preserve leading zeros
    const columnsToFormat = [0, 1, 3]; // `fecha`, `monto`, `numero`

    rows.forEach((row, rowIndex) => {
        if (rowIndex > 0) {
            columnsToFormat.forEach((colIndex) => {
                if (colIndex === 0 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(0, "0"); // Ensure leading zeros remain
                }

                if (colIndex === 1 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(0, "0"); // Ensure leading zeros remain
                }

                if (colIndex === 3 && row[colIndex]) {
                    row[colIndex] = row[colIndex].padStart(0, "0"); // Ensure leading zeros remain
                }
            });
        }
    });

    // Convert the rows array into a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(rows);

    // Apply text format to specific cells to preserve leading zeros
    const columnsToFormatAsText = ["A", "B", "D"]; // Example columns with leading zeros
    Object.keys(worksheet).forEach((cell) => {
        if (cell !== "!ref") {
            const column = cell.match(/[A-Z]+/)[0]; // Get column letter
            if (columnsToFormatAsText.includes(column) && cell !== `${column}1`) {
                worksheet[cell].z = "@"; // '@' sets the cell format to text
            }
        }
    });

    const newWorkbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(newWorkbook, worksheet, "Sheet1");

    generateExcelBlobAndDownload(newWorkbook, fileName, extension);
};

export const parseFileContent = (blobContent, requestType, fileResponse) => {
    const content = blobContent
        .split("\n")
        .slice(0)
        .map((line, i) => {
            if (requestType && requestType === "MassiveEcheq") {
                const [
                    echeqPayDay,
                    amount,
                    beneficiaryDocumentType,
                    beneficiaryDocumentNumber,
                    BeneficiaryEmail,
                    reference,
                    caracter,
                    concept,
                    beneficiaryName,
                    state, // este dato al parecer no viene
                    cuitEmit, // este dato al parecer no viene
                ] = line.split(";");
                return {
                    echeqPayDay,
                    beneficiaryDocumentType,
                    beneficiaryDocumentNumber,
                    creditAmountQuantity: amount,
                    BeneficiaryEmail,
                    reference,
                    caracter,
                    concept,
                    nameEmit: fileResponse?.data?.data?.nameEmit,
                    state,
                    cuitEmit,
                    creditCuit: fileResponse?.data?.data?.creditCuit,
                    lineNumber: i + 1,
                    beneficiaryName,
                };
            }

            const [productType, currency, cbu, cuit, amount, voucher, motivo, referenc, nameEmmit] = line.split(";");
            return {
                productType,
                currency,
                cbu,
                cuit,
                creditAmountQuantity: amount,
                voucher,
                motivo,
                referenc,
                lineNumber: i + 1,
                nameEmmit,
            };
        });

    return content;
};
